import axios from 'axios'

const url = 'linkdrive/plataforma/acesso-publico/pacote/lista'
const urlPrivate = 'linkdrive/plataforma/acesso-privado/pacotes'

const state = {
  pacotes: [],
  aquisicoes: [],
  beneficios: [],
  paymentLink: {}
}

const getters = {
  pacotes: state => state.pacotes,
  aquisicoes: state => state.aquisicoes,
  beneficios: state => state.beneficios,
  paymentLink: state => state.paymentLink
}

const mutations = {
  setPacotes: (state, payload) => state.pacotes = payload,
  setPaymentLink: (state, payload) => state.paymentLink = payload,
  setAquisicoes: (state, payload) => state.aquisicoes = payload,
  setBeneficios: (state, payload) => state.beneficios = payload,
}

const actions = {
  async getPacotes({ commit }) {
    const { data: pacotes } = await axios(`${url}/50/pagina/1`)
    commit('setPacotes', pacotes)
  },
  async getPaymentLink({ commit }, params) {
    const resp = await axios.post(`${urlPrivate}/mp-pgto/payment-create`, {
      params
    }).catch(err => {
      console.error(err);
      return {data: 'Erro ao criar o pagamento', error: true}
    })
    commit('setPaymentLink', resp)
    return resp
  },
  async getMinhasAquisicoes({ commit }) {
    const { data: aquisicoes } = await axios(`${urlPrivate}/minhas-aquisicoes`)
    if(aquisicoes.length){
      aquisicoes.map(a => {
        if(a['detalhes-pacote'].length){
          a.detalhesPacote = a['detalhes-pacote']
          a.beneficios = a['detalhes-pacote']
        }
        if(a.beneficios.length) a.beneficios.map(b => {
          b.titulo = b.detalhe_beneficio
          return b
        })
      })
      aquisicoes.lista = [...aquisicoes]
    }

    commit('setAquisicoes', aquisicoes)
  },
  
  async getBeneficios({ commit }) {
    const { data: beneficios } = await axios(`${urlPrivate}/beneficios-disponiveis`)
    commit('setBeneficios', beneficios)
  },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}